import * as core from '../../../../../../../core'

import { query } from './save-subaward.query'

export const RESOURCE = {
  payload: {
    alias: 'sr.save-subaward',
    description: 'Save Subaward',
    name: 'Save Subaward',
    query,
  },
  type: core.quiver.Resource.Type.MosaicAction,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicAction>
